export { default as getRetentionDuration } from './helpers/getRetentionDuration';
